import { render, staticRenderFns } from "./Lgx02616959701502117544331.vue?vue&type=template&id=4976ddda&scoped=true&"
import script from "./Lgx02616959701502117544331.vue?vue&type=script&lang=js&"
export * from "./Lgx02616959701502117544331.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02616959701502117544331.vue?vue&type=style&index=0&id=4976ddda&prod&lang=scss&scoped=true&"
import style1 from "./Lgx02616959701502117544331.vue?vue&type=style&index=1&id=4976ddda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4976ddda",
  null
  
)

export default component.exports